module.exports = __webpack_public_path__ + "static/media/immigration2007.c179371e.jpg";